var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-diy-list"},[_c('div'),_vm._m(0),_c('div',{staticClass:"add"},[_c('button',{on:{"click":_vm.goto}},[_vm._v("+ 现在去定制")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',[_c('li')])])
}]

export { render, staticRenderFns }